angular.module('gym.contacts').factory('Members', ["Restangular", "$rootScope", function(Restangular, $rootScope) {
  var params;
  params = $rootScope.toParams;
  return Restangular.one('gyms', params.gymId).all('members');
}]);
